import { render } from "./dashboard.vue?vue&type=template&id=c5e286e8"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__